import { render, staticRenderFns } from "./basecompletadiaria.vue?vue&type=template&id=088be116"
import script from "./basecompletadiaria.vue?vue&type=script&lang=js"
export * from "./basecompletadiaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports